import { useGetPartner } from '@services/api/partners';
import { AvatarWithFallback } from '@components/Avatars/AvatarWithFallback';
import { mdiImagePlusOutline } from '@mdi/js';

type PartnerPictureAvatarProps = {
  whiteBackground?: boolean;
};
export const PartnerPictureAvatar = ({ whiteBackground }: PartnerPictureAvatarProps) => {
  const { partner } = useGetPartner();

  return (
    <AvatarWithFallback
      fallbackIcon={mdiImagePlusOutline}
      uri={partner?.logotypeUri}
      whiteBackground={whiteBackground}
    />
  );
};
